import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceiveCall = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "receiveCall",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17358",
		"data-name": "Group 17358",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12806",
				"data-name": "Path 12806",
				d: "M10.131,13.869A12.634,12.634,0,0,1,7.493,10.06a.75.75,0,0,1,.166-.827l.819-.819a1.53,1.53,0,0,0,.085-2.206L7.39,5.035a2,2,0,0,0-2.828,0l-.652.651a3.194,3.194,0,0,0-.85,2.87,15.715,15.715,0,0,0,4.461,7.923,15.715,15.715,0,0,0,7.923,4.461,3.194,3.194,0,0,0,2.87-.85l.651-.651a2,2,0,0,0,0-2.828l-1.173-1.173a1.5,1.5,0,0,0-2.121,0l-.9.9a.749.749,0,0,1-.827.166,12.678,12.678,0,0,1-3.81-2.639Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12807",
				"data-name": "Path 12807",
				d: "M15,3V9h6",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12808",
				"data-name": "Path 12808",
				d: "M21,3,15,9",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12809",
		"data-name": "Path 12809",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgReceiveCall;
